import { ApolloLink } from '@apollo/client';
import isBrowser from '../util/isBrowser';

export const sessionExpiredHeaderKey = 'X-Session-Expired';

const sessionExpiredLink = new ApolloLink((operation, forward) => {
  return forward(operation).map(response => {
    const context = operation.getContext();

    if (!context?.response) {
      return response;
    }

    const sessionExpired = context.response.headers.get(
      sessionExpiredHeaderKey
    );

    if (sessionExpired && isBrowser) {
      window.location.href = `/auth/sign_out`;
    }

    return response;
  });
});

export default sessionExpiredLink;
